const AppMedicationAdministration =()=> import('./medication-administration.vue');
import { guardRoute } from '../guardRouter';

import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'

const Setup = () => import('./setup/setup.vue');
//const Medications = () => import('./setup/medications/medications.vue');
const Medication = () => import('./setup/medication/medication.vue');

export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}
const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

const medicationAdministrationRoutes = [
    {
        path: '/medication-administration',
        name: 'medication-administration',
        component: AppMedicationAdministration,
        meta: {
            title: translation[lang].Nav.MedicationAdministration.MedicationAdministration,
        },
        children: [
            //setup
            {
                path: 'setup',
                name: 'setup',
                meta: {
                    title: translation[lang].Nav.MedicationAdministration.Setup,
                },
                component: Setup,
                children: [               
                    //{
                    //    path: 'medications',
                    //    name: 'setup/medications',
                    //    meta: {
                    //        title: translation[lang].Nav.MedicationAdministration.Medications,
                    //    },
                    //    component: Medications
                    //},   
                    {
                        path: 'medication',
                        name: 'setup/medication',
                        meta: {
                            title: translation[lang].Nav.MedicationAdministration.Medications,
                        },
                        component: Medication
                    },    
                ]
            },

        ],
        beforeEnter: guardRoute
    }
];

export default medicationAdministrationRoutes;
